'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useEffect, useState } from 'react';
import { TextField } from '../TextField';
import { PasswordFieldMaskingToggle, ForgotPasswordLink } from './elements';
export const PasswordField = /*#__PURE__*/React.forwardRef(({
  showPassword: showPasswordOverride = false,
  showMaskingToggle = false,
  forgotPasswordHref,
  forgotPasswordLabel,
  affixRight = null,
  disabled = false,
  containerStyle = {},
  ...restProps
}, fRef) => {
  const [showPassword, setShowPassword] = useState(showPasswordOverride);
  useEffect(() => {
    if (typeof showPasswordOverride != 'undefined') {
      setShowPassword(showPasswordOverride);
    }
  }, [showPasswordOverride]);
  const inputType = showPassword ? 'text' : 'password';
  const forgotPasswordHrefPresent = !!forgotPasswordHref;
  return /*#__PURE__*/React.createElement("div", {
    "data-aui": "password-field",
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'end',
      ...containerStyle
    }
  }, /*#__PURE__*/React.createElement(TextField, _extends({
    ref: fRef,
    type: inputType,
    affixRight: showMaskingToggle ? /*#__PURE__*/React.createElement(PasswordFieldMaskingToggle, {
      "data-testid": "password-field-masking-toggle",
      onClick: e => {
        e.stopPropagation();
        setShowPassword(!showPassword);
      }
    }, showPassword ? 'Hide' : 'Show') : affixRight,
    disabled: disabled,
    affixRightClickable: showMaskingToggle
  }, restProps)), forgotPasswordHrefPresent && /*#__PURE__*/React.createElement(ForgotPasswordLink, {
    href: forgotPasswordHref,
    color: "secondary",
    disabled: disabled,
    className: disabled ? 'disabled' : ''
  }, forgotPasswordLabel ?? 'Forgot password?'));
});